/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface IObjectSchemaEditorScope extends ng.IScope {
        model: ObjectSchemaEditorModel;
        objectSchema: Wars.Domain.Model.ObjectSchema;
        processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        readOnly: boolean;
        schemaChangedCallback: () => void;
        reloadSchema: () => void;
        hideIsRequired: string;
        hideIsIndexed: string;
        defaultIsIndexedValue: string;
        defaultIsRequiredValue: string;
        allowTieToSystemVariable: string;
        allowTieToProcessName: string;
        isSystemLevel: string;
        allowList: string;
        codeGroups: Wars.Domain.Model.Codes.CodeGroup[];
    }

    export class ObjectSchemaEditor implements IDirective {
        public link($scope: IObjectSchemaEditorScope, element: JQuery, attrs: ng.IAttributes, controller: ObjectSchemaEditorController) { }
        public templateUrl = './app/views/directives/objectSchemaEditor.html';
        public restrict: string = 'E';
        public controller = ['$scope', 'schemaPropertyService', 'systemLevelService', 'objectSchemaService', ObjectSchemaEditorController];
        public controllerAs = 'controller';
        public scope: any = {
            objectSchema: "=",
            readOnly: "=",
            schemaChangedCallback: "=",
            processConfiguration: "=",
            reloadSchema: "=",
            hideIsRequired: '@',
            hideIsIndexed: '@',
            defaultIsIndexedValue: "@",
            defaultIsRequiredValue: "@",
            allowTieToSystemVariable: '@',
            allowTieToProcessName: '@',
            isSystemLevel: "@",
            allowList: "@",
            codeGroups: "="
        };
    }

    export class ObjectSchemaEditorModel {

        public systemVariableObjectSchema: Wars.Domain.Model.ObjectSchema;

        constructor(
            public objectSchema: Wars.Domain.Model.ObjectSchema,
            private processConfiguration: Wars.Domain.Model.ProcessConfiguration,
            private readOnly: boolean,
            private schemaChangedCallback: () => void,
            private reloadSchema: () => void,
            private schemaPropertyService: services.SchemaPropertyService,
            private objectSchemaService: services.ObjectSchemaService,
            private defaultIsIndexedValue: string,
            private defaultIsRequiredValue: string,
            private isSystemLevel: string,
            private allowList: boolean)
        { }

        public addProperty(): void {
            var schemaProperty = this.schemaPropertyService.createNewSchemaProperty();
            this.setDefaults(schemaProperty);
            this.objectSchema.properties.push(schemaProperty);
            this.schemaChangedCallback();
        }

        public addListProperty(): void {
            var newTopLevelSchemaProperty = this.schemaPropertyService.createNewSchemaProperty();
            this.setDefaults(newTopLevelSchemaProperty);
            newTopLevelSchemaProperty.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.List;
            this.objectSchema.properties.push(newTopLevelSchemaProperty);
            var newObjectSchema = this.objectSchemaService.createNewListObjectSchema();
            newTopLevelSchemaProperty.typeSchema = newObjectSchema;
            newTopLevelSchemaProperty.type_id = newTopLevelSchemaProperty.typeSchema.id;
            this.schemaChangedCallback();
        }

        private setDefaults(propertySchema: Wars.Domain.Model.SchemaProperty): void {
            if (this.defaultIsIndexedValue === "true") {
                propertySchema.isIndexed = true;
            }
            else if (this.defaultIsIndexedValue === "false") {
                propertySchema.isIndexed = false;
            }

            if (this.defaultIsRequiredValue === "true") {
                propertySchema.required = true;
            }
            else if (this.defaultIsRequiredValue === "false") {
                propertySchema.required = false;
            }

            if (this.isSystemLevel === "true") {
                propertySchema.isSystemLevel = true;
            }
        }
    }

    export class ObjectSchemaEditorController implements IController {

        constructor(
            private $scope: IObjectSchemaEditorScope,
            schemaPropertyService: services.SchemaPropertyService,
            systemLevelService: services.SystemLevelService,
            objectSchemaService: services.ObjectSchemaService)
        {
            var schemaChangedFunction = () => {
                if ($scope.schemaChangedCallback) {
                    $scope.schemaChangedCallback();
                }
            }

            var reloadSchemaFunction = () => {
                if ($scope.reloadSchema) {
                    $scope.reloadSchema();
                }
            };

            $scope.model = new ObjectSchemaEditorModel(
                $scope.objectSchema,
                $scope.processConfiguration,
                $scope.readOnly,
                schemaChangedFunction,
                reloadSchemaFunction,
                schemaPropertyService,
                objectSchemaService,
                $scope.defaultIsIndexedValue,
                $scope.defaultIsRequiredValue,
                $scope.isSystemLevel,
                $scope.allowList === "true");

            if ($scope.allowTieToSystemVariable === "true") {
                systemLevelService.getSystemLevel()
                    .then((systemLevel) => {
                        objectSchemaService.getObjectSchemaExpanded(systemLevel.variableSchema_id)
                            .then((objectSchema) => {
                                $scope.model.systemVariableObjectSchema = objectSchema;
                            });
                    });
            }

            $scope.$watch('objectSchema', (newValue: Wars.Domain.Model.ObjectSchema) => {
                $scope.model.objectSchema = newValue;
            });
        }
    }
}

warsApp.registerDirective('ObjectSchemaEditor', []);